import { hrmsGet, hrmsPatch } from "../api/api";

/** GET /saas/hrms/dasboards/configurations/get — HR35S */
export async function fetchDashboardConfigs() {
  const response = await hrmsGet("/dashboards/configurations/get", "HR35S");
  return Array.isArray(response?.data) ? response.data : [];
}

/** PATCH /saas/hrms/dashboards/configurations/update — HR35U. Bulk: { dashboards: [{ dashboardId, enabled }] }. */
export async function updateDashboardConfigs(dashboards) {
  const response = await hrmsPatch("/dashboards/configurations/update", { dashboards }, "HR35U");
  return response?.data ?? null;
}

export const dashboardConfigService = { fetchDashboardConfigs, updateDashboardConfigs };

export default dashboardConfigService;
